export enum TablePictureEnum {
    Table2 = './assets/images/tables/t2.svg',
    Table3 = './assets/images/tables/t3.svg',
    Table4 = './assets/images/tables/t4.svg',
    Table5 = './assets/images/tables/t5.svg',
    Table6 = './assets/images/tables/t6.svg',
    Table8 = './assets/images/tables/t8.svg',
    Table10 = './assets/images/tables/t10.svg',
}

export class TableTypeConfigModel {

  static readonly Table2  = new TableTypeConfigModel('Table2', 2);
  static readonly Table3  = new TableTypeConfigModel('Table3', 3);
  static readonly Table4  = new TableTypeConfigModel('Table4', 4);
  static readonly Table5  = new TableTypeConfigModel('Table5', 5);
  static readonly Table6  = new TableTypeConfigModel('Table6', 6);
  static readonly Table8  = new TableTypeConfigModel('Table8', 8);
  static readonly Table10  = new TableTypeConfigModel('Table10', 10);

  // private to disallow creating other instances of this type
  private constructor(private readonly key: string, public readonly value: number) {
  }

  toString() {
    return this.key;
  }
}

export class TableShapeConfigModel {

  static readonly Table2  = new TableShapeConfigModel('Table2',2);
  static readonly Table3  = new TableShapeConfigModel('Table3', 2);
  static readonly Table4  = new TableShapeConfigModel('Table4', 2);
  static readonly Table5  = new TableShapeConfigModel('Table5', 0);
  static readonly Table6  = new TableShapeConfigModel('Table6', 0);
  static readonly Table8  = new TableShapeConfigModel('Table8', 0);
  static readonly Table10  = new TableShapeConfigModel('Table10', 0);

  // private to disallow creating other instances of this type
  private constructor(private readonly key: string, public readonly value: any) {
  }

  toString() {
    return this.key;
  }
}

export const enum TableShape {
  Rectangle_Horizontal = 0 ,
  Rectangle_Vertical = 1,
  Square = 2,
  Round = 3
}
